<div class="aayn-create-ad--header" header>
  <div class="aayn-create-ad--header--objective">
    <div class="aayn-create-ad--header--objective__name" *ngIf="objectiveType">{{ objectiveType }}</div>
  </div>
</div>
